import React, { useEffect } from "react";
import "./SuccessSection.scss";
import AnimatedSection from "../../components/Ui/AnimatedSection";
import TechnologyGIF from "../../assets/images/technology.gif";
import { Link } from "react-router-dom";
const SuccessSection = () => {
  const stats = [
    { label: "Client Satisfaction", percentage: 92, color: "#FF8F00", delay: 400 },
    { label: "Successful Projects", percentage: 90, color: "#FF3D71", delay: 500 },
    { label: "On-Time Delivery", percentage: 85, color: "#8A3FFC", delay: 600 },
    { label: "Repeat Business Rate", percentage: 95, color: "#4F80FF", delay: 700 },
  ];

  useEffect(() => {
    const bars = document.querySelectorAll(".success-progress-bar-fill");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            const value = e.target.getAttribute("data-percentage");
            e.target.style.width = value + "%";
          }
        });
      },
      { threshold: 0.4 }
    );

    bars.forEach((bar) => observer.observe(bar));
  }, []);

  return (
    <section id="success" className="success-section">
      <div className="success-container">
        <div className="success-grid">
          <AnimatedSection delay={200}>
            <div className="success-graphic-wrapper">
              <img
                src={TechnologyGIF}
                alt="Technology and Data"
                className="success-tech-graphic"
              />
            </div>
          </AnimatedSection>

          <div className="success-content-wrapper">
            <AnimatedSection delay={300}>
              <h2 className="success-title">
                We Are Increasing Business Success With
                <span className="success-highlight-text"> Technology</span>
              </h2>
            </AnimatedSection>

            <AnimatedSection delay={400}>
              <p className="success-description">
                Over 13+ years working in IT services developing software applications
                and mobile apps for clients across the world.
              </p>
            </AnimatedSection>

            <div className="success-progress-bars-container">
              {stats.map((stat, index) => (
                <AnimatedSection key={index} delay={stat.delay}>
                  <div className="success-progress-item">
                    <span className="success-progress-label">{stat.label}</span>
                    <span className="success-progress-percentage"  style={{ color: stat.color }}>
                      {stat.percentage}%
                    </span>

                    <div className="success-progress-bar-track">
                      <div
                        className="success-progress-bar-fill"
                        data-percentage={stat.percentage}
                        style={{ background: stat.color }}
                      ></div>
                    </div>
                  </div>
                </AnimatedSection>
              ))}
            </div>

            <AnimatedSection delay={800}>
              <Link to="contact-us" className="success-btn-primary">
                Learn More About Our Tech
              </Link>
            </AnimatedSection>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SuccessSection;
